/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventTitle: NonNullable<unknown> }} Checkinqrimagealt3Inputs */

const en_checkinqrimagealt3 = /** @type {(inputs: Checkinqrimagealt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check-in code for ${i?.eventTitle}`)
};

const de_checkinqrimagealt3 = /** @type {(inputs: Checkinqrimagealt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check-in-Code für ${i?.eventTitle}`)
};

/**
* | output |
* | --- |
* | "Check-in code for {eventTitle}" |
*
* @param {Checkinqrimagealt3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrimagealt3 = /** @type {((inputs: Checkinqrimagealt3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrimagealt3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrimagealt3(inputs)
	return de_checkinqrimagealt3(inputs)
});
export { checkinqrimagealt3 as "checkinQrImageAlt" }